export default __webpack_public_path__ + "static/media/Kado.666d8f95.svg";